export default __webpack_public_path__ + "static/media/list.23e22c07.svg";